module.exports = __webpack_public_path__ + "img/03-round-not-convex-1.0f735b3f.svg";